"use strict";
exports.__esModule = true;
exports.tokens = exports.authenticationMethods = exports.permissions = exports.data = void 0;
exports.data = [
    {
        uuid: 'uuid1',
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@emample.com',
        status: { id: 3 },
        instance: {
            uuid: 'uuid1'
        },
        lang: 'en',
        logDateAdded: new Date()
    },
    {
        uuid: 'uuid2',
        firstName: 'Jane',
        lastName: 'Doe',
        email: 'jane.doe@emample.com',
        status: { id: 1 },
        instance: {
            uuid: 'uuid1'
        },
        lang: 'en',
        logDateAdded: new Date()
    }
];
exports.permissions = [
    {
        id: 1,
        name: 'app',
        UserPermission: [{ uuid: 'uuid1' }]
    },
    {
        id: 2,
        name: 'admin',
        UserPermission: [{ uuid: 'uuid2' }]
    }
];
exports.authenticationMethods = [
    {
        id: 1,
        type: {
            id: 1,
            name: 'GitHub'
        },
        value: 'asdf',
        isEnabled: true
    }
];
exports.tokens = [
    {
        uuid: 'uuid1',
        issuedDate: new Date('2021-04-01 14:00:00'),
        expirationDate: new Date('2021-05-31 15:00:00')
    },
    {
        uuid: 'uuid2',
        issuedDate: new Date('2021-05-01 14:00:00'),
        expirationDate: new Date('2021-06-31 15:00:00')
    }
];
